module.exports = "//static.hsappstatic.net/react-codemirror/static-1.8657/theme/hubspot-canvas-dark.sass"